import * as React from 'react';

import { PropertyInfoSectionViewModel } from 'models';

import { UitkFigure, UitkFigureAspectRatioType, UitkQueuedImage } from 'uitk-react-images';

import { SectionPlainText } from './section-text';

interface SectionImageLayoutProps {
  propertyInfo: PropertyInfoSectionViewModel;
}

export const SectionImageLayout = ({ propertyInfo }: SectionImageLayoutProps) => {
  const propertySectionInformation = propertyInfo && propertyInfo.sections && propertyInfo.sections.length > 0 && propertyInfo.sections[0];
  const propertySectionFormattedDescription =
    propertySectionInformation &&
    propertySectionInformation.formattedDescriptions &&
    propertySectionInformation.formattedDescriptions.length > 0 &&
    propertySectionInformation.formattedDescriptions[0];
  const propertySectionTitle = propertySectionInformation && propertySectionInformation.title;
  const propertySectionDescription = propertySectionFormattedDescription && propertySectionFormattedDescription.description;

  if (!propertyInfo.image) {
    return null;
  }

  return (
    <div className="section-image-layout uitk-grid">
      {propertyInfo.image && (
        <div className="all-cell-1-6 all-r-padding-three uitk-cell">
          <UitkFigure ratio={UitkFigureAspectRatioType.R1_1} className="all-image-fit-contain">
            <UitkQueuedImage src={propertyInfo.image.src} alt={propertyInfo.image.caption} />
          </UitkFigure>
        </div>
      )}
      {propertySectionTitle && (
        <div className="uitk-cell all-cell-fill">
          <h4 className="policies__header--secondary uitk-type-heading-500 uitk-type-bold">{propertySectionTitle}</h4>
          {propertySectionDescription && <SectionPlainText description={propertySectionDescription} />}
        </div>
      )}
    </div>
  );
};

SectionImageLayout.displayName = 'SectionImageLayout';
